const PropTypes = require('prop-types');
// @ vendors
const React = require('react');

// @ components
const OKModal = require('components/commons/OKModal/OKModal');

class Modal extends React.Component {
    constructor() {
        super();

        this.state = {
            isLoading: false
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({ isLoading: nextProps.isDeleting });
    }

    render() {
        const { config } = this.props;

        return (
            <OKModal
                description={config.text.body}
                footerType="navigation"
                isOpen={true}
                onCloseCallback={config.handlers.handleClose}
                onPrimaryButtonClick={config.handlers.handleClickBtn}
                onSecondaryButtonClick={config.handlers.handleClose}
                primaryButtonText={config.text.confirmButton}
                primaryButtonLoading={this.state.isLoading}
                secondaryButtonText={config.text.cancelButton}
                title={config.text.title}
            />
        );
    }
}

Modal.propTypes = {
    config: PropTypes.object,
    isDeleting: PropTypes.bool
};
module.exports = Modal;
